import { apiSlice } from "../../../apiSlice";

export const armdimxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    getDataDeclarations: builder.mutation({
      query: ({ page = 1, perPage = 15, filters = {}, DOCNROXX }) => {
        const filterParams = Object.entries(filters).reduce((acc, [key, value]) => {
          acc[`filters[${key}]`] = value;
          return acc;
        }, {});

        return {
          url: `/Modimpxx/Nacional/Armdimxx/getDataDeclarations/${DOCNROXX}`,
          method: "GET",
          params: { page, perPage, ...filterParams },
        };
      },
    }),
    getSummaryExcel: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/getSummaryExcel/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getSumaryBase: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/getSumaryBase/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getSumaryValaduxx: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/getSumaryValaduxx/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getSumaryTax: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/getSumaryTax/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getDesgloseReport: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/getDesgloseReport/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    showDataArmdimxx: builder.mutation({
      query: ({ DOCNROXX, SUBIDXXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/${DOCNROXX}/${SUBIDXXX}`,
        method: "GET",
      }),
    }),
    updateDataArmdimxx: builder.mutation({
      query: ({ DOCNROXX, SUBIDXXX, body }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/${DOCNROXX}/${SUBIDXXX}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["keyResultImpo", "Create"],
    }),
    //Liquidacion en RIO 360 (Diego 2026-10-16): resumen, generacion en el modulo de declaraciones y traza del intento
    getResumenLiquidacion: builder.query({
      query: ({ DOCNROXX }) => ({ url: `/Modimpxx/Nacional/Armdimxx/resumenRio/${DOCNROXX}`, method: "GET" }),
      providesTags: ["keyResultImpo"],
    }),
    generarLiquidacion: builder.mutation({
      query: ({ DOCNROXX }) => ({ url: `/Dimdavxx/Armdimxx`, method: "POST", body: { DOCNROXX } }),
    }),
    //Volver a radicar (Diego 2026-10-23): el radicado viejo pasa al historial y la declaracion corregida se regenera y se radica de nuevo
    volverARadicar: builder.mutation({
      query: ({ DOCNROXX, MOTIVO }) => ({ url: `/Modimpxx/Nacional/Armdimxx/volverARadicar/${DOCNROXX}`, method: "POST", body: { MOTIVO } }),
      invalidatesTags: ["keyResultImpo", "Create"],
    }),
    anotarIntentoLiquidacion: builder.mutation({
      query: ({ DOCNROXX, OK, DETALLE }) => ({ url: `/Modimpxx/Nacional/Armdimxx/anotarIntento/${DOCNROXX}`, method: "POST", body: { OK, DETALLE } }),
      invalidatesTags: ["keyResultImpo", "Create"],
    }),
    saveArmdimxx: builder.mutation({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Nacional/Armdimxx/save/${DOCNROXX}`,
        method: "POST",
      }),
      invalidatesTags: ["keyResultImpo", "Create"],
    }),
  }),
});

export const {
  useGetResumenLiquidacionQuery,
  useGenerarLiquidacionMutation,
  useAnotarIntentoLiquidacionMutation,
  useGetDataDeclarationsMutation,
  useGetSummaryExcelMutation,
  useGetSumaryBaseMutation,
  useGetSumaryValaduxxMutation,
  useGetSumaryTaxMutation,
  useGetDesgloseReportMutation,
  useShowDataArmdimxxMutation,
  useUpdateDataArmdimxxMutation,
  useSaveArmdimxxMutation,
  useVolverARadicarMutation,
} = armdimxxApiSlice;
